<section class="widget-section">
  <div class="container pt-5 pb-6">
    <app-archive-project-form></app-archive-project-form>
  </div>
</section>
